module.exports = __webpack_public_path__ + "img/File.c1710cca.svg";